var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticClass: "mb14",
          attrs: { "body-style": { padding: "10px 20px 0 20px" } },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "cr-header-tabs",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "未读", name: "1" } }),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { label: "全部", name: "2" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      false
        ? _c("el-card", { staticClass: "content employees-card" }, [
            _c(
              "div",
              { staticClass: "mb14" },
              [
                _c("form-box", {
                  ref: "formBox",
                  on: { confirmData: _vm.confirmData },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb20" },
                  [
                    _vm.activeName == 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.handleIsRead },
                          },
                          [_vm._v("标记为已读")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.handleDelete },
                      },
                      [_vm._v("批量删除")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "table",
                    attrs: { data: _vm.tableData },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "45" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "查看", width: "50" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-image", {
                                  attrs: {
                                    src:
                                      scope.row.is_read === 0
                                        ? require("@/assets/images/unread-icon.png")
                                        : require("@/assets/images/read-icon.png"),
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2760299212
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "title",
                        label: "消息标题",
                        "min-width": "100",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "message",
                        label: "消息内容",
                        "min-width": "360",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "cate_name",
                        label: "类型",
                        "min-width": "90",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "created_at",
                        label: "发送时间",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "100", fixed: "right" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDetails(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("查看详情")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3406383156
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination mt14" },
              [
                _c("el-pagination", {
                  attrs: {
                    "page-size": _vm.where.limit,
                    "current-page": _vm.where.page,
                    "page-sizes": [10, 15, 20],
                    layout: "total, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.pageChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("dialog-form", {
        ref: "dialogForm",
        attrs: {
          "roles-config": _vm.rolesConfig,
          "form-data": _vm.formBoxConfig,
        },
        on: {
          isOk: function ($event) {
            return _vm.getList()
          },
        },
      }),
      _vm._v(" "),
      _c("message-details", {
        ref: "messageDetails",
        attrs: { "message-data": _vm.messageData },
        on: { isOk: _vm.isOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }